import { FC } from 'react';

import { Box, Button, List, ListItem, Typography } from '@mui/material';
import clsx from 'clsx';

import { ReactComponent as DropdownArrow } from 'assets/icons/DropdownArrow.svg';

import { IViewProps } from './types';

import styles from './SectionsNavigationItem.module.scss';

export const DesktopView: FC<IViewProps> = ({
  isSectionActive,
  icon,
  onSectionClick,
  onSubsectionItemClick,
  label,
  subsections,
  activeSubsection,
  isIconToTheRight = false,
}) => {
  return (
    <Box className={clsx(styles.dropdownContainer, { [styles.active]: isSectionActive })} key={label}>
      <Button
        fullWidth
        className={clsx(styles.selectButton, { [styles.reverse]: isIconToTheRight })}
        onClick={onSectionClick}
      >
        <Box className={styles.iconWrapper}>{icon}</Box>
        <Typography variant="h6" className={styles.title}>
          {label}
        </Typography>
        {!!subsections?.length && (
          <DropdownArrow className={clsx(styles.dropdownIcon, { [styles.active]: isSectionActive })} />
        )}
      </Button>
      {isSectionActive && !!subsections?.length && (
        <List className={styles.selectList}>
          {subsections.map(({ id, label }) => (
            <ListItem
              key={id}
              className={clsx(styles.selectItem, {
                [styles.activeItem]: isSectionActive && activeSubsection === id,
              })}
              onClick={() => onSubsectionItemClick(id)}
            >
              {label}
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  );
};
